module.exports = __webpack_public_path__ + "img/GAME_GOSTOP.2cafdda3.jpg";